import React from 'react';
import HomeAIHeader from './components/HomeAIHeader';
import HomeAICard from './components/HomeAICard';
import NavBottomMenu from './components/NavBottomMenu';
import AIEventsSection from './components/AIEventsSection';

const HomeAIPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center min-h-screen bg-[#0A0118] text-white">
      <div className="w-full max-w-md">
        <HomeAIHeader />
        <div className="px-5 mt-6 relative">
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[24px] overflow-hidden"
            style={{
              width: '100%',
              height: '100%',
              background:
                'linear-gradient(167.02deg, #03040E 3.07%, #170259 39.2%, #401DBD 65.26%, #AAA8FF 78.98%, #1E1E1E 94.07%)',
              filter: 'blur(100px)',
              zIndex: 1,
            }}
          ></div>
          <HomeAICard />
        </div>
        <AIEventsSection />
      </div>
      <NavBottomMenu />
    </div>
  );
};

export default HomeAIPage;
